import React from "react";
import { NavLink } from "react-router-dom";

const services = [
  {
    count: "01",
    title: "Personalized Design Approach",
    flaticon: "flaticon-sketch",
    image: require("./../../images/services/service-projects/1.png"),
    description:
      "We take a client-centered approach, creating interiors that reflect your individual tastes and functional requirements. Each design is uniquely tailored to fit your vision.",
  },
  {
    count: "02",
    title: "Creative and Modern Concepts",
    flaticon: "flaticon-stairs",
    image: require("./../../images/services/service-projects/2.png"),
    description:
      "Our team stays ahead of design trends, using cutting-edge techniques and materials to create interiors that are innovative, stylish, and timeless.",
  },
  {
    count: "03",
    title: "High-Quality Materials and Finishes",
    flaticon: "flaticon-window",
    image: require("./../../images/services/service-projects/3.png"),
    description:
      "We source only the best materials and finishes to ensure that every aspect of your interior design is of the highest quality, from custom furniture to lighting and accessories.",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class InteriorDesignService7 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full mobile-page-padding p-t80 p-b50 bg-white">
          <div className="container">
            <div className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <h3 className="sep-line-one">
                  Core Reasons to Choose Studio Sarva Architects for Interior Design
                  </h3>
                </div>
              </div>
            </div>
            <div className="row">
              {services.map((item, index) => (
                <div className="col-lg-4 col-md-12 m-b30" key={index}>
                  <div
                    className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
                    style={{ backgroundImage: "url(" + item.image + ")" }}
                  >
                    <div className="overlay-main bg-black opacity-05" />
                    <div className="bg-content-mid-outer">
                      <div className="bg-content-mid">
                        <div className="sx-icon-box-wraper center   text-white">
                          <div className="icon-lg m-b15">
                            <span className="icon-cell">
                              <i className={item.flaticon} />
                            </span>
                          </div>
                          <div className="icon-content m-b30">
                            <h4 className="sx-tilte">
                              {" "}
                              <NavLink
                                to={"/services-detail"}
                                className="sx-text-white"
                              >
                                {item.title}
                              </NavLink>
                            </h4>
                            <p>{item.description}</p>
                          </div>
                        </div>
                        <span className="bgcall-block-number">
                          {item.count}
                        </span>
                        <div className="bg-overlay" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default InteriorDesignService7;
